import "./header.css"
import logo from "../img/llargerlogo.png"
import { NavLink } from 'react-router-dom';
import React, { useState } from 'react';
import menuIcon from "../img/menu.png"
import backIcon from "../img/back.png"

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((open) => !open);
  };

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="header">
      <div className="nav">
        <div className="header_items">
          <div className="logo_name">
            <img src={logo} alt="logo" className="logo"></img>
            <h1 className="name">UNISFERA</h1>
          </div>
          <button className="menu-btn" onClick={handleMenuToggle} aria-label="Menu">
            <img src={menuOpen ? backIcon : menuIcon} alt="Menu" className="menu-icon" />
          </button>
          <nav className={`navbtns${menuOpen ? ' open' : ''}`}>
            <NavLink to="/" className={({ isActive }) => isActive ? 'navbtn active navbtnshiny' : 'navbtn'} onClick={handleNavClick}>HOME</NavLink>
            <NavLink to="/events" className={({ isActive }) => isActive ? 'navbtn active' : 'navbtn'} onClick={handleNavClick}>EVENTS</NavLink>
            <NavLink to="/register" className={({ isActive }) => isActive ? 'navbtn active' : 'navbtn'} onClick={handleNavClick}>REGISTER</NavLink>
            <NavLink to="/aboutUs" className={({ isActive }) => isActive ? 'navbtn active' : 'navbtn'} onClick={handleNavClick}>ABOUT US</NavLink>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;
